import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { TermsAndConditionsRequest } from "types/schemas";
import { QueryKeys } from "../QueryKeys";
import { useApi } from "../useApi";

export const useUpdateTermsAndConditionsStatus = (params?: { onSuccess?: () => void; onError?: () => void }) => {
  const { api } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (status: TermsAndConditionsRequest) => api.patient.updateTermsAcceptedStatus(status),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.fetchTermsAndConditionsStatus],
      });
      if (params?.onSuccess) {
        params.onSuccess();
      }
    },
  });
};
